export const auditDataRoutes = {   
    UPLOAD_EXCEL: "audit-data-ui/audit-data-excel"
};

export const AUDIT_TEMPLATE_URL = "https://hub.textileexchange.org/viewdocument/te-mm-tem-201-materials-matter-audit-data-collection-tool";

